var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132142 1.99778C0.0475686 2.08514 -2.86102e-06 2.20405 -2.86102e-06 2.3281C-2.86102e-06 2.45215 0.0475686 2.57106 0.132142 2.65842L1.9191 4.51937C2.00231 4.60532 2.11462 4.65377 2.23182 4.65429C2.35057 4.655 2.4647 4.60646 2.54901 4.51937C2.63358 4.43201 2.68115 4.3131 2.68115 4.18905C2.68115 4.065 2.63358 3.94609 2.54901 3.85873L1.07923 2.3281L2.54007 0.79747C2.65339 0.679459 2.69765 0.507453 2.65617 0.346247C2.61469 0.18504 2.49378 0.0591233 2.33898 0.0159281C2.18419 -0.0272671 2.01902 0.0188216 1.9057 0.136833L0.132142 1.99778Z",
    fill: "#40A0C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02722 2.33429C5.02722 2.09322 4.8318 1.8978 4.59073 1.8978H1.33031C1.08924 1.8978 0.893817 2.09322 0.893817 2.33429C0.893817 2.57535 1.08924 2.77077 1.33031 2.77077H4.59073C4.8318 2.77077 5.02722 2.57535 5.02722 2.33429Z",
    fill: "#40A0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLeftIcon);
export default __webpack_public_path__ + "static/media/small-left-icon.251bbc1f75e2a19f91513969e10d21c9.svg";
export { ForwardRef as ReactComponent };